import React, { useState, useEffect } from 'react'
import { Dropdown } from 'react-bootstrap'

const RadioDropdown = (props) => {

  // keep a local display value but sync it with the parent-provided title
  const [selectVal, setSelectVal] = useState(props.title || "");

  useEffect(() => {
    setSelectVal(props.title || "");
  }, [props.title]);


  return (
    <div className='d-block d-md-none bg-white radio-dropdown'>
     
      <Dropdown>
      <Dropdown.Toggle
        variant="success"
        id="dropdown-basic"
        className='d-block toggle-button'
        aria-label={props.labelText ? `${props.labelText} dropdown` : 'Topics dropdown'}
      >
       {props.labelText ? (
        <div className="text-sub-title-20 radio-dropdown-label">{props.labelText}</div>
      ) : null}
        {selectVal ? selectVal : props.options[0]?.title}
      </Dropdown.Toggle>

      <Dropdown.Menu >
        {props.options?.map((item, index) => {
          return <Dropdown.Item key={index} as={'button'} className={props.title === item.title ? "active" : ""} disabled={item.isDisable || false} onClick={(e) => { setSelectVal(e.target.textContent); props.onChange(item.title, item.slug)}}>{item.title}</Dropdown.Item>
        })}
      </Dropdown.Menu>
    </Dropdown>
    </div>
  )
}

export default RadioDropdown
